export const olive = {
  1: { value: { base: '{colors.olive.light.1}', _dark: '{colors.olive.dark.1}' } },
  2: { value: { base: '{colors.olive.light.2}', _dark: '{colors.olive.dark.2}' } },
  3: { value: { base: '{colors.olive.light.3}', _dark: '{colors.olive.dark.3}' } },
  4: { value: { base: '{colors.olive.light.4}', _dark: '{colors.olive.dark.4}' } },
  5: { value: { base: '{colors.olive.light.5}', _dark: '{colors.olive.dark.5}' } },
  6: { value: { base: '{colors.olive.light.6}', _dark: '{colors.olive.dark.6}' } },
  7: { value: { base: '{colors.olive.light.7}', _dark: '{colors.olive.dark.7}' } },
  8: { value: { base: '{colors.olive.light.8}', _dark: '{colors.olive.dark.8}' } },
  9: { value: { base: '{colors.olive.light.9}', _dark: '{colors.olive.dark.9}' } },
  10: { value: { base: '{colors.olive.light.10}', _dark: '{colors.olive.dark.10}' } },
  11: { value: { base: '{colors.olive.light.11}', _dark: '{colors.olive.dark.11}' } },
  12: { value: { base: '{colors.olive.light.12}', _dark: '{colors.olive.dark.12}' } },
  a1: { value: { base: '{colors.olive.light.a1}', _dark: '{colors.olive.dark.a1}' } },
  a2: { value: { base: '{colors.olive.light.a2}', _dark: '{colors.olive.dark.a2}' } },
  a3: { value: { base: '{colors.olive.light.a3}', _dark: '{colors.olive.dark.a3}' } },
  a4: { value: { base: '{colors.olive.light.a4}', _dark: '{colors.olive.dark.a4}' } },
  a5: { value: { base: '{colors.olive.light.a5}', _dark: '{colors.olive.dark.a5}' } },
  a6: { value: { base: '{colors.olive.light.a6}', _dark: '{colors.olive.dark.a6}' } },
  a7: { value: { base: '{colors.olive.light.a7}', _dark: '{colors.olive.dark.a7}' } },
  a8: { value: { base: '{colors.olive.light.a8}', _dark: '{colors.olive.dark.a8}' } },
  a9: { value: { base: '{colors.olive.light.a9}', _dark: '{colors.olive.dark.a9}' } },
  a10: { value: { base: '{colors.olive.light.a10}', _dark: '{colors.olive.dark.a10}' } },
  a11: { value: { base: '{colors.olive.light.a11}', _dark: '{colors.olive.dark.a11}' } },
  a12: { value: { base: '{colors.olive.light.a12}', _dark: '{colors.olive.dark.a12}' } },
}
